export default __webpack_public_path__ + "static/greg-blockx-a4c2ae0641dcb0516c7419c8c91119da.jpeg";